"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = exports.formatDiscount = exports.formatPrice = void 0;
const ocm_object_1 = require("./ocm-object");
const LOCALES = {
    de: "de-DE",
    at: "de-AT",
    ch: "de-CH",
    int: "en-GB",
};
const CURRENCY = ocm_object_1.country === "ch" ? "CHF" : "EUR";
const CURRENCY_SYMBOLS = {
    CHF: "CHF",
    EUR: "€",
};
const priceFormatter = new Intl.NumberFormat(LOCALES[ocm_object_1.country], {
    useGrouping: false,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
const formatPrice = (price, currency = CURRENCY) => {
    // currency symbol should always be displayed before the price, no matter the country's formatting standard
    return `${CURRENCY_SYMBOLS[currency]} ${priceFormatter.format(Number(price))}`;
};
exports.formatPrice = formatPrice;
const formatDiscount = (percentage) => `-${Math.floor(Math.abs(Number(percentage)))}%`;
exports.formatDiscount = formatDiscount;
const numberFormatter = new Intl.NumberFormat(LOCALES[ocm_object_1.country]);
const formatNumber = (number) => numberFormatter.format(Number(number));
exports.formatNumber = formatNumber;
